import Vue from 'vue'
import '@/utils/vConsole'

window.Vue = Vue
// 全局引入
Vue.use(window.uif.default)

export default Vue
